<template>
	<article class="wikiContentOverflow">
		<!-- <TextCtrl v-show="editorMode" :editor="textEditor" @save="saveContent"></TextCtrl> -->
		<div  class="wikiWrap" ref="wikiWrap" :key="resetCount">
			<WikiIndex :indexList=titleIndex @itemSelect="checkTitlePosition" @mounted="data=>bookmarkInfo=data"></WikiIndex>
			<div class="contentsWrap">
				<Writer v-if="isWriter.isWriter"
					:item="isWriter"
					@updated="getRefs"
				></Writer>
				<Process v-if="isProcess.isProcess && processType == 'NORMAL'"
					:item="isProcess"
					@updated="getRefs"
				></Process>
				<Keyword v-if="isKeyword.isKeyword"
					:item="isKeyword"
					@updated="getRefs"
					:editorSelect = "editorSelect"
					:deactivate="deactivate"
					:readonly="readonly"
				></Keyword>
				<WikiContentes v-for="(data, index) in editorList" :editor="data" :key="index" 
					:flip = "flipContent"
					:editorSelect = "editorSelect"
					:active="activeEdit"
					:deactivate="deactivate"
					:index="index"
					:save="saveContent"
					@updated="getRefs"
					:editable="true"
					:readonly="readonly"
					>
				</WikiContentes>
			</div>
		</div>
		<Loading :visible="loading" type="fixed"/>
		<UnitSearch @getUnit="getProtocolUnit"></UnitSearch>
		<!-- <print-test /> -->
		<pdf-wiki />
	</article>
	
</template>

<script>
import Vue, { onBeforeMount } from "vue";
import { v4 } from "uuid";
import CommNew, {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import {Editor, EditorContent} from '@tiptap/vue-2'

import WikiContentes from './wikiContents.vue'
import BtnLink from '../btns/BtnLink.vue'
import Loading from '../common/loading.vue'

import Writer from './wikiWriter.vue'
import Process from './wikiProcess.vue'
import Keyword from './wikiKeyword.vue'
// import Keyword from './wikiKeyword_tiptap.vue'
import WikiIndex from './wikiIndex.vue'
import TextCtrl from './textStyleCtrl.vue'
import UnitSearch from './wikiUnitSearch.vue'
import PrintTest from '@common/PrintTest' ; 
import PDFWiki from '@components/pdf/PDFWiki' ; 
import MakeNodesInfomation from '@components/platform_new/wikiApi.js'

let makeNodes = new MakeNodesInfomation();

export default {
	async beforeDestroy () {
		/**
		 * 나모웹 에디터가 활성화 되어 있는 상태에서 페이지가 이동되게 되면 나모웹에서 타이밍 문제로 오류를 호출 함 
		 * 나모웹 에디터가 동작하는 시간 보다 vue에서 페이지 전환 시키는 속도가 더 빠름
		 * 그래서 강제로 에디터를 삭제 시켜줘야 함 
		 * 하지만 나모웹을 삭제 시키기 때문에 작성된 컨텐츠를 불러올 수가 없기 때문에 저장을 하기는 힘듬
		 */
		this.textEditor = null; 

		this.updateStatus({ protocolTabMoveBln : false }) ; 
		if ( this.user.name != 'AxiosError' ) {
			this.updateStatus({ protocolTabMoveBln : true }) ; 
		}
	} , 
	props: {
		readonly: {
			type: Boolean,
			default: false
		},		
	},	
	components: {
		EditorContent, TextCtrl, WikiContentes, Loading, BtnLink, WikiIndex,
		Writer, Process, Keyword, UnitSearch, 
		PrintTest, 
		'pdf-wiki' : PDFWiki , 
	},
	mixins: [CommNew],
	data () {
		return {
			Nodes : {}, // nodeskeymap이 생성 되는 동시에 생성
			editorMode: false,
			activeEdit: '',
			textEditor: null,
			editor: null,
      editorDatas: {},
			editorList: [],
			nodesKeyMap: {}, // 이슈리스트가 변경 될 경우 생성
			titleIndex: [],
      selectedEquimentData: false,
			loading: false,
			contentRefs: {},
			selectedIssue: null,
			nodeDeleteAlert: false,
			nodeMemoInfo: {},
			isWriter: false,
			isProcess: false,
			isKeyword: false,
			wikiContentHanlder: null,
			selectedProtocolData : null,
			testCount: 0,
			scrollTimer: null,
			bookmarkInfo: null,
			processType: null,
			resetCount: 0,
		}
	},
	filters: {
		
	},
	watch: {
		'$route.query.protocolId'(id) {
			console.log('Wiki change protocolId : ', id);
			this.initFunc( this.protocolIssueList ) ;
		}, 
		'status.protocolTabMoveBln'(bln) {
			console.log("wiki ~~~~~~ : ", bln);
			if ( bln ) {
				this.initFunc( this.protocolIssueList ) ; 					
			}
		} , 
	},
	computed: {

  },
	async mounted() {
		const loadProcess = await this.$wApi.process.detail(null, this.$route.query.processId);
		this.processType = loadProcess.processType ; 
		if(this.status.protocolTabMoveBln === true) {
			await this.initFunc( this.protocolIssueList ) ; 
		}
	},
	methods: {
		saveBeforStringChkFun(data) {
			return new Promise( resolve => {
				const loopFunc = _=> {
					if ( typeof data.json == 'object' ) {
						resolve(data.json) ; 
					} else {
						data.json = JSON.parse( data.json ) ; 
						if ( typeof data.json == 'string' ) {
							loopFunc() ; 
						} else {
							resolve(data.json) ; 
						}
					}
				}
				loopFunc() ; 
			}) ; 
		},
		updateSelectProtocolInfo() {
			let { protocols } = this.PROCESS_INFO ; 
			let { protocolId } = this.$route.query ;
			let slctProtocol = protocols.filter( protocol => protocol.id == protocolId )[0] ; 
			this.selectedProtocolData = slctProtocol || this.selectedProtocolData;
			return {slctProtocol, protocols}
		},
		async initFunc ( value ) {
			makeNodes = new MakeNodesInfomation();
			let selectedData;
			this.selectedIssue = this.$route.query.protocolId;
			this.loading = true;
			const loadProtocol = await this.$wApi.protocol.gets({
				processId : this.$route.query.processId , 
				isMemo : true , 
				isConent : true , 
				isComment : true , 
			}) ; 
			for(const item of loadProtocol) {
				if(this.selectedIssue == item.id) {
					selectedData = item;
					break
				}
			}

			if( !selectedData || selectedData.json.init == true ){
				this.$emit('change')
				return;
			}

			const dataInfo = await this.saveBeforStringChkFun(selectedData);
			if(selectedData.nodeMemo) {
				makeNodes.setNodeMemos = JSON.parse(selectedData.nodeMemo);
			}
			if(selectedData.nodeContent){
				makeNodes.setNodeContents = JSON.parse(selectedData.nodeContent);
			}
			this.selectedProtocolData = selectedData;
			let rltIssues = this.nodeToValue(dataInfo.issues);
			rltIssues.forEach(node => {
				if(node.protocolId != selectedData.id){
					node.protocolId = selectedData.id;
				}
			});
			this.Nodes = makeNodes.makeNodeList(rltIssues);
			this.editorList = [];
			this.editorList = await this.setTemplateData(this.Nodes[0].child)
			this.resetCount++;
			this.loading = false;
		} , 
		nodeToValue(nodes){
			const parents = nodes.filter(o=>o.T === true);
			let res = nodes;
			for( let { key } of parents ){
				const parent = res.filter(o=>o.key == key )[0];
				parent["nodeValue"] = nodes.filter(o=>o.parent == key && o.display !== false ).map(o=>o.text).join(",");
				res = res.filter(o=>o.parent != key);
			}
			return res;
		},
		
		async setTemplateData (nodeMap) {
      let contents = [];
			this.loading = true;
			if(this.titleIndex.length > 0){
				this.titleIndex  = [];
				this.contentRefs = {};
				this.isWriter  = false;
				this.isProcess = false;
				this.isKeyword = false;
			} 
			nodeMap.map( (item)=>{
				if(item.hasOwnProperty('isWriter')) {
					this.isWriter	= item
					this.titleIndex.push(item);
					this.contentRefs[item.key] = item
				}
				else if(item.hasOwnProperty('isProcess')) {
					this.isProcess = item
					this.titleIndex.push(item);
					this.contentRefs[item.key] = item
				}
				else if(item.hasOwnProperty('isKeyword')) {
					this.isKeyword = item
					this.titleIndex.push(item);
					this.contentRefs[item.key] = item
				}
				else {
					this.titleIndex.push(item);
				}
			} )

			contents = await makeNodes.makeListData(nodeMap);
			this.loading = false
			return contents
		},
		getRefs(items) {
			if(items.depth < 1) {
				this.contentRefs[items.key] = items
			}
		},
		editorSelect(data, editor, methods) {
			if(this.editorMode === true) {
				this.editorMode = null;
				this.saveContent(this.textEditor.getContent());
			} else {
				this.editorMode = true;
			}
			this.textEditor = editor;
			this.saveContent = async (textContent) => {
        if(this.readonly){
          return;
        }
				textContent = textContent.replace(/font-family\s*:\s*([^;]+);/gi, '');
				// textContent = JSON.stringify(textContent);
				const response = await this.$wApi.protocol.protocolContent.put({
					protocolId: data.protocolId,
					tagKey: data.key,
					content: textContent
				});
				if( response.code ){
					await this.$wApi.protocol.protocolContent.put({
						protocolId: data.protocolId,
						tagKey: data.key,
						content: "<p><br/></p>"
					});					
					let rlt = await this.$wApi.protocol.protocolContent.put({
						protocolId: data.protocolId,
						tagKey: data.key,
						content: textContent
					});
					if( rlt.code ){
						window.alert("위키 내용이 저장되지 못했습니다. 관리자에게 문의하세요.")
					}else{
						window.wToast('위키 수정내용이 저장 되었습니다.', { variant: "wtoast-bg", });
					}		
					this.editorMode = null;
				}else{
					this.editorMode = null;
					window.wToast('위키 수정내용이 저장 되었습니다.', { variant: "wtoast-bg", });
				}
			}
			this.getProtocolUnit = (unit) => {
				let html = unit.content.replace(/^"(.*)"$/,'$1');
				html = html.replace(/\\"/gi, '"');
				html = html.replace(/\\n/gi, '');
				editor.InsertValue(1, `<div class="refUnit" style="border: 1px dashed #67A1E3; border-radius: 5px; padding: 20px;">
					${html}
					<p class="refInfo" style="fontSize:12px; color:#999; text-align: right">[참조] ${unit.name}  ${unit.createdDate} ${unit.userName}</p>
				</div>`);
			}
		},
		saveContent () {},
		async flipContent (status, data, step) {
			let hasChildren = makeNodes.nodeMap.get(data.key).child
			let target = this.editorList

			if(data.child.length == 0 && hasChildren) {
				for(let index of step) {
					target = target[index].child
				}
				// target.concat(hasChildren.child)
				this.loading = true
				let children = await makeNodes.makeListData(hasChildren)
				for(let child of children) {
					target.push(child)
				}
				this.loading = false
			}
		},
		deactivate() {
			if(!this.textEditor) return;
			if(this.editorMode === null) {
				this.editorMode = true
			}else {
				this.editorMode = false
				this.saveContent(this.textEditor.getContent());
			}
		},
		checkTitlePosition(key) {
			if(!key || !this.contentRefs) return
			if(typeof key !== 'string') {
				key = key.item?.key ? key.item.key : key.item.tagKey;
			}
			let clientRect = this.contentRefs[key].title.getBoundingClientRect()
			this.$refs.wikiWrap.scrollTop = this.$refs.wikiWrap.scrollTop + clientRect.top - 150
		},
		getProtocolUnit(result) {
			// 텍스트 에디터 선택 시 editorSelect 에서 함수 리턴 받음
		},
		moveScroll(e){
      clearTimeout(this.scrollTimer);
      let before=null;
      const checkPosition = (refPos) => {
        let index=0, height=0;
        for(let [key, item] of Object.entries(this.contentRefs)) {
          let rect = item.title.getBoundingClientRect();
          if(before) {
            refPos = refPos - height;
            height = rect.top - before.rect.top;
            if( height - (height/3) > refPos) {
              this.bookmarkInfo.handler.select(index-1);
              break;
            }
          }
          before = {item, rect};
          index++
        }
      }
      this.scrollTimer = setTimeout(()=>{
        checkPosition(this.$refs.wikiWrap.scrollTop + 150)
      }, 100);
    }
	}
}
</script>

<style lang="scss">
@import './wiki.scss';

</style>